/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Image, Popover } from "antd";
import { useState } from "react";
import { moveOrRemoveCrewFromSchedule } from "../../../../ducks/services";
import dayjs from "dayjs";
import { useAppDispatch } from "../../../../../../config/hooks";
import {
  getScheduleByDay,
  getScheduleByWeek,
  getSchedulingFormData,
} from "../../../../ducks/actions";
import { SuccessMessage } from "../../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../../atoms/Toasts/ErrorMessage";

function PopOverCrewChange(props: any) {
  const { crewDrop, memberId, selectedDate, weekStartDate } = props;
  const dispatch = useAppDispatch();
  const [openInner, setOpenInner] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpenInner(newOpen);
  };

  const moveCrewMember = (memberIdToMove: string, newCrewId: string) => {
    const payload = {
      crew_attendance_id: memberIdToMove,
      move_to_schedule_id: newCrewId,
    };

    moveOrRemoveCrewFromSchedule(payload)
      .then(() => {
        if (weekStartDate) {
          const payload = {
            date: dayjs(weekStartDate).format("YYYY-MM-DD"),
          };
          dispatch(
            getScheduleByWeek(dayjs(weekStartDate).format("YYYY-MM-DD"))
          );
          dispatch(getSchedulingFormData(payload));
        }
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage("Crew member removed");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          ErrorMessage("Something went wrong");
        }
      });

    setOpenInner(false); // Close the popover
  };

  return (
    <Popover
      trigger={["click"]}
      arrow={false}
      placement="right"
      open={openInner}
      onOpenChange={handleOpenChange}
      overlayClassName="crewChangePopover"
      content={
        <div>
          <h4>Move crew member to:</h4>
          {crewDrop?.map((item: any) => (
            <div
              key={item.value}
              style={{
                marginTop: 4,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 4,
              }}
            >
              <Button
                type="text"
                onClick={(e) => {
                  e.stopPropagation();
                  moveCrewMember(memberId, item.value);
                }}
                style={{
                  padding: "6px 12px",
                  marginLeft: "-12px",
                }}
              >
                {item.label}
              </Button>
            </div>
          ))}
        </div>
      }
    >
      <Button
        className="btn-sm"
        icon={<Image src="/images/schedule/move-btn.svg" preview={false} />}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </Popover>
  );
}

export default PopOverCrewChange;
